import React, { Children, ReactNode, forwardRef } from "react";
import ChallengeDropdownSection, {
  Challenge,
} from "./ChallengeDropdownSection";

type InteractiveTableStepsProps = {
  selectedChallenge?: Challenge | null;
  setSelectedChallenge?: (arg: Challenge | null) => void;
  children?: ReactNode;
};

type ChallengeDropdownProps = {
  selectedChallenge?: Challenge | null;
  setSelectedChallenge?: (arg: Challenge | null) => void;
  [key: string]: unknown;
};

const InteractiveTableSteps = forwardRef<
  HTMLDivElement,
  InteractiveTableStepsProps & React.HTMLAttributes<HTMLDivElement>
>(
  (
    { children, selectedChallenge, setSelectedChallenge, ...attributes },
    ref,
  ) => {
    const childrenWithProps = Children.map(children, (child) => {
      if (
        React.isValidElement(child) &&
        child.type === ChallengeDropdownSection
      ) {
        return React.cloneElement(
          child as React.ReactElement<ChallengeDropdownProps>,
          {
            selectedChallenge,
            setSelectedChallenge,
          },
        );
      }
      return child;
    });

    return (
      <div
        ref={ref}
        {...attributes}
        className="mx-auto hidden items-start justify-center gap-8 lg:flex lg:flex-auto lg:shrink-0"
      >
        {childrenWithProps}
      </div>
    );
  },
);
InteractiveTableSteps.displayName = "InteractiveTableSteps";

export default InteractiveTableSteps;
